(function () {
    'use strict';
    $(document).ready(function () {

        jQuery.each(languages, function(i, val) {
            $(".langpicker .dropdown-menu li.lang-" + i + " a").attr('href', val.url);
        });

        //smooth scroll to
        $('.scroll-animation').on('click', function (e) {
            e.preventDefault();

            var href = $(this).attr('href');
            if (href) {
                $("html, body").animate({
                    scrollTop: $(href).offset().top
                }, 1000);
            }
        });

        $('.scroll-animation a').on('click', function (e) {
            e.stopPropagation();
        });

        //Menu mobile toggle
        $(".menu-toggle").click(function () {
            $('.menu-overlay').fadeToggle().toggleClass('open');
            $(this).toggleClass("open");
        });

        //Linki posiadające podmenu - wyłączenie domyślnego zachowania
        $("#site-menu > li.menu-item-has-children > a").click(function (e) {
            e.preventDefault();
        });

        // $("#site-menu li.menu-item-has-children > ul," +
        //     "#site-menu li.menu-item-has-children > ul > li").click(function (e) {
        //     // e.stopPropagation();
        // });

        //Mainmenu - level 0
        $(window).on('resize', function () {
            $('#site-menu li.menu-item-has-children.open')
                .removeClass('open')
                .css('display', '');

            $(".menu-toggle.open").removeClass('open');
            $('.menu-overlay.open').fadeOut(function () {
                $(this).removeClass('open');
                $(this).css('display', '');
            })
        })
        $("#site-menu > li.menu-item-has-children").click(function () {
            if (window.matchMedia("(min-width: 1025px)").matches) {
                $(this).children('ul').fadeToggle({
                    start: function () {
                        $(this).css({
                            display: "flex"
                        })
                    }
                });

                if ($(this).hasClass('open')) {
                    $(this).removeClass('open');
                } else {
                    $(this).addClass('open');
                }

                $(this).siblings('li').removeClass('open');
                $(this).siblings('li').children('ul').fadeOut();

            }
        });

        $("#site-menu li.menu-item-has-children > a").click(function (e) {
            if (window.matchMedia("(max-width: 1024px)").matches) {
                e.preventDefault();
                const $this = $(this).parent();
                $this.toggleClass('open');
                $this.find('>ul').slideToggle();
                $this.siblings('li')
                    .toggleClass('open')
                    .find('>ul').slideUp();
            }
        });

        $("#site-menu li.menu-item-has-children.current-page-item > ul > li > a").click(function (e) {
            $("#site-menu > li > ul").fadeOut();
        });

        //Hide mainmenu by clicking outside
        $(document).click(function (e) {
            if (window.matchMedia("(min-width: 1025px)").matches) {
                if (!$(e.target).is('#site-menu, #site-menu *')) {
                    $("#site-menu > li.menu-item-has-children").removeClass('open');
                    $("#site-menu > li > ul").fadeOut();
                }
            }
        });

        //Search trigger
        $('.search-trigger').click(function () {
            $(this).toggleClass('active');
            $('.search-panel').fadeToggle('active');
            return false;
        });

        //Contact form sending logic
        $('#cf-back').on('click', function (e) {
            e.preventDefault();
            $('.ajax-success').slideUp();
            $('.contact-form-wrapper').slideDown();
        });

        if ($('.form_subscribe').length) {
            $('.form_subscribe input').each(function () {
                if ($(this).attr('name') === 'form[taxlegal]' || $(this).attr('name') === 'form[accounting]') {
                    $(this).parent().remove();
                }
            });

            const taxlegal = $(`
                <div class="cb">
                    <p>
                        <input type="checkbox" value="on" name="form[taxlegal]" id="fm_taxlegal" class="service">
                        <label for="fm_taxlegal">
                            <span class="checkbox"></span>
                            <span>Tax&Legal</span>
                        </label>
                    </p>
                </div>
            `);
            const accouting = $(`
                <div class="cb">
                    <p>
                        <input type="checkbox" value="on" name="form[accounting]" id="fm_accounting" class="service">
                        <label for="fm_accounting">
                            <span class="checkbox"></span>
                            <span>Accounting</span>
                        </label>
                    </p>
                </div>
            `);

            const $fm_form_agree = $('#fm_form_agree');
            $fm_form_agree.siblings('span')
                .replaceWith(function () {
                    return $('<label />', {html: `<span>${$(this).html()}</span>`})
                        .attr('for', 'fm_form_agree')
                        .prepend('<span class="checkbox"></span>');
                })
                .parent()
                .wrap('<div />')

            $fm_form_agree.parent().wrap('<div class="cb"></div>')

            $('form.form_subscribe > div:nth-of-type(2)')
                .append(taxlegal)
                .append(accouting);
        }

        function sendContactForm() {

            var cfNames = $('input[name=cf-names]', '#formularz').val();
            var cfEmail = $('input[name=cf-email]', '#formularz').val();
            var cfCompany = $('input[name=cf-company]', '#formularz').val();
            var cfPhone = $('input[name=cf-phone]', '#formularz').val();
            var cfMessage = $('textarea[name=cf-message]', '#formularz').val();

            var fdata = new FormData();

            fdata.append("action", "send_email");
            fdata.append("names", cfNames);
            fdata.append("email", cfEmail);
            fdata.append("company", cfCompany);
            fdata.append("phone", cfPhone);
            if ($("#email_to").length) {
                fdata.append("email_to", $("#email_to").val());
            }
            fdata.append("message", cfMessage);

            if ($('#input-file').length && $('#input-file')[0].files.length > 0) {
                fdata.append("file", $('#input-file')[0].files[0]);
            }

            $.ajax({
                url: "/wp-admin/admin-ajax.php",
                method: "post",
                timeout: 10000,
                data: fdata,
                processData: false,
                contentType: false,
                success: function () {
                    $('.ajax-success').slideDown();
                    $("#formularz").trigger("reset");
                    $('.contact-form-wrapper').slideUp();
                },
                error: function () {
                    $('.ajax-error').slideDown();
                },
                beforeSend: function () {
                    $('.ajax-success').slideUp();
                    $('.ajax-loading').slideDown();
                    $('.ajax-error').slideUp();
                },
                complete: function () {
                    $('.ajax-loading').slideUp();
                },
            });
        }

        function validateEmail(email) {
            const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return re.test(String(email).toLowerCase());
        }

        $(".input-file .plus, .input-file .file-names").on('click', function () {
            $(this).parent().find('input[type="file"]').click();
        })

        $("#input-file").on("change", function (e) {
            var files = e.currentTarget.files; // puts all files into an array
            var file = files[0];
            var filesize = ((file.size / 1024) / 1024).toFixed(4); // MB

            if (file.name !== "item" && typeof file.name != "undefined" && filesize <= 2) {
                $(".file-names").text(file.name).removeClass('error');
            } else {
                $(".file-names").text("Plik nieprawidłowy").addClass('error');
            }
        });

        $('#cf-submit').on('click', function (e) {
            e.preventDefault();
            $('.cf-error').hide();
            $('.ajax-success').slideUp();
            $('.ajax-loading').slideUp();
            $('.ajax-error').slideUp();
            //if ( (validateEmail($('#cf-email').val()) === false) || (!$('#cf-message').val()) || (!$('#cf-consent').is(':checked')) ) {
            if ((!$('#cf-names').val()) || (validateEmail($('#cf-email').val()) === false) || (!$('#cf-message').val()) || (!$('#acceptation').is(":checked"))) {

                if (!$('#cf-names').val()) {
                    $('#cf-names').siblings('.cf-error').slideDown();
                }

                if (validateEmail($('#cf-email').val()) === false) {
                    $('#cf-email').siblings('.cf-error').slideDown();
                }

                if (!$('#cf-message').val()) {
                    $('#cf-message').siblings('.cf-error').slideDown();
                }

                if(!$('input[name=acceptation]', '#formularz').is(":checked")){
                    $('#acceptation').parent().siblings('.cf-error').slideDown();
                }

                // if (!$('#cf-consent').is(':checked')) {
                //     $('#cf-consent').siblings('.cf-error').slideDown();
                // }
            } else {
                sendContactForm();
            }
        });


        $('#newsletterModal .close-modal').on('click', function () {
            $('#newsletterModal').modal('hide')
        })

    });
}(jQuery));
